import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from '../../../../modal/js/react-modal';
import RegisterFormBanner from '../../forms/one-club-register/RegisterFormBanner';

function ConfirmationModal({
    isOpen,
    children,
    inputText,
    onModalClose,
    onApproveClick,
    isApproveDanger,
    isApproveButtonDisabled,
    onCancelClick,
    isCancelButtonDisabled,
    masterCardDialogBoxBanner
}) {
    function displayModal() {
        if (!isOpen) {
            return null;
        }
        

        return (
            <ReactModal isOpen={isOpen} onCloseCb={onModalClose}>
                <div className='modal__content center-vertical'>
                    <RegisterFormBanner
                        formBanner={masterCardDialogBoxBanner}
                    ></RegisterFormBanner>
                    <div className='modal__content form-container__dialogBox'>
                        <div className='confirm-action-modal auto-ph-md constrain-tablet'>
                            {children}
                            <div className='modal-button-container'>
                                {!isCancelButtonDisabled && <button
                                    className='button button--primary auto-mt-md'
                                    onClick={onCancelClick}
                                    data-dc-form-sso-ref='submit-button'>
                                    <span className='button-content button-content--icon'>
                                        <span>{'Cancel'}</span>
                                        <svg
                                            className='icon button__arrow-right'
                                            width='14'
                                            height='12'
                                            focusable='false'>
                                            <use xlinkHref='#icon-arrow-right' />
                                        </svg>
                                    </span>
                                </button>}
                                {!isApproveButtonDisabled &&
                                    <button
                                        className={`${isApproveDanger ? 'confirm-action-button-danger' : ''} confirm-action-button button button--primary auto-mt-md`}
                                        onClick={onApproveClick}
                                        disabled={isApproveButtonDisabled}
                                        data-dc-form-sso-ref='submit-button'>
                                        <span className='button-content button-content--icon'>
                                            <span>{inputText}</span>
                                            <svg
                                                className='icon button__arrow-right'
                                                width='14'
                                                height='12'
                                                focusable='false'>
                                                <use xlinkHref='#icon-arrow-right' />
                                            </svg>
                                        </span>
                                    </button>}
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>);
    }

    return displayModal();
}


ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    inputText: PropTypes.string.isRequired,
    onModalClose: PropTypes.func.isRequired,
    onApproveClick: PropTypes.func.isRequired,
    isApproveDanger: PropTypes.bool,
    isApproveButtonDisabled: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
};

export default ConfirmationModal;
